var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import RadioGroupUI from '../../../uikit/inputs/RadioGroup';
import { noop } from '../../../utils/noop';
// @todo: add possibility to disable specific field
export function RadioGroup(props) {
    var _a = props.onChange, onChange = _a === void 0 ? noop : _a, _b = props.onBlur, onBlur = _b === void 0 ? noop : _b, _c = props.onFocus, onFocus = _c === void 0 ? noop : _c, value = props.value, colProps = props.colProps;
    var precisedColProps = useMemo(function () {
        if (typeof colProps !== 'undefined') {
            return colProps;
        }
        if (props.options && props.options.length === 2) {
            return { xs: 6 };
        }
        return { xs: 12, sm: 6 };
    }, [colProps]);
    var _d = useState(value), selectedValue = _d[0], setSelectedValue = _d[1];
    useEffect(function () {
        value !== selectedValue && setSelectedValue(value);
    }, [value]);
    var handleChange = useCallback(function (ev, value) {
        setSelectedValue(value);
        onChange(value, ev);
    }, [onChange]);
    var handleBlur = useCallback(function (ev) {
        onBlur(selectedValue, ev);
    }, [onBlur, selectedValue]);
    return (React.createElement(RadioGroupUI, __assign({ colProps: precisedColProps }, props, { onChange: handleChange, onBlur: handleBlur, onFocus: onFocus })));
}
